import { DaysCheckBoxInput } from "@/components/dayscheckboxgroup";
import { Typography } from "@mui/material";
import {
  Create,
  DateInput,
  ImageField,
  ImageInput,
  minValue,
  NumberInput,
  required,
  SimpleForm,
  TextInput,
  useTranslate,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const ProductOfferedFormFields = () => {
  const translate = useTranslate();
  const today = new Date().toISOString().split("T")[0];
  const startAt = useWatch({ name: "start_at" });

  const computeMinEndAt = () => {
    if (!startAt) return "";
    const date = new Date(startAt);
    if (isNaN(date.getTime())) return "";

    date.setDate(date.getDate() + 7);
    return date.toISOString().split("T")[0];
  };

  const minEndAt = computeMinEndAt();

  return (
    <>
      <ImageInput
        source="file"
        accept={{ "image/*": [".png", ".jpg", ".jpeg"] }}
        placeholder={translate("ra.gameoo.voucherThumbnailPlaceHolder")}
        multiple={false}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <Typography>Produit</Typography>
      <TextInput source="item" label="Nom de produit" validate={[required()]} />
      <Typography>Valeur</Typography>
      <NumberInput
        source="discount_value"
        label="Montant (en Ariary)"
        validate={[required(), minValue(3000)]}
        min={3000}
        step={1}
      />
      <Typography>Quantité</Typography>
      <NumberInput
        source="quantity"
        label="Quantité"
        validate={[required(), minValue(1)]}
        min={1}
        step={1}
      />
      <Typography>Date de validité</Typography>
      <DateInput
        source="start_at"
        label="Début"
        validate={[required()]}
        slotProps={{
          input: {
            inputProps: {
              min: today,
            },
          },
        }}
      />
      <Typography>Au</Typography>
      <DateInput
        source="end_at"
        label="Fin"
        validate={[required()]}
        slotProps={{
          input: {
            inputProps: {
              min: minEndAt || today,
            },
          },
        }}
      />
      <Typography>Jour de validité</Typography>
      <DaysCheckBoxInput source="day_validity" validate={[required()]} />
      <Typography>Description</Typography>
      <TextInput
        source="description"
        label="Description"
        multiline
        minRows={4}
        fullWidth
        validate={[required()]}
      />
    </>
  );
};

const ProductOfferedCreate = () => {
  const navigate = useNavigate();

  return (
    <Create
      transform={(data) => ({
        ...data,
        voucher_type: "free_product",
        discount_type: "fixed",
      })}
      mutationOptions={{
        onSuccess: () => {
          navigate("/vouchers");
        },
      }}
    >
      <SimpleForm>
        <ProductOfferedFormFields />
      </SimpleForm>
    </Create>
  );
};

export default ProductOfferedCreate;
